// import {
//   AnySourceImpl,
//   CanvasSourceRaw,
//   GeoJSONSourceOptions,
//   ImageSource,
//   ImageSourceOptions,
//   VectorSource,
//   VideoSource,
//   VideoSourceRaw,
// } from "mapbox-gl";
import { useMemo, useState } from "react";
import { useEffect } from "react";
let sourceCounter = 0;
/**
 * Adds a new Source to the map and removes it, when component is removed from tree.
 * MUST be nested within the MapSDK component.
 * Should nest one or more Layer components.
 * @param props
 * @returns
 */
export const Source = (props) => {
    const map = props.map;
    const sourceData = props.sourceData;
    const id = useMemo(() => props.id || `jsx-source-${sourceCounter++}`, []);
    const [source, setSource] = useState();
    const imageCoordinates = [
        sourceData.coordinates != null
            ? // @ts-ignore
                sourceData.coordinates[0]
            : null,
        sourceData.coordinates != null
            ? // @ts-ignore
                sourceData.coordinates[1]
            : null,
    ];
    const removeSource = () => {
        map.removeSource(id);
    };
    const updateSource = () => {
        if (!sourceData)
            return;
        switch (sourceData.type) {
            case "raster":
                // updateRaster(props);
                break;
            case "raster-dem":
                // updateRasterDem(props);
                break;
            case "vector":
                updateVector(sourceData);
                break;
            case "canvas":
                updateCoordinates(sourceData);
                break;
            case "video":
                updateCoordinates(sourceData);
                break;
        }
    };
    const updateGeoJSONData = () => {
        if (sourceData.type !== "geojson")
            return;
        const data = sourceData
            .data;
        if (data) {
            map.setFeatures(id, data);
        }
        else {
            console.warn("Give GeoJSON source was not correct for: ", id, data);
        }
    };
    const updateImageURL = () => {
        if (!source || !sourceData || !("url" in sourceData))
            return;
        source.updateImage({
            // @ts-ignore Isn't the line above enough, dear TS?
            url: sourceData.url,
        });
    };
    const updateImageCoordinates = () => {
        if (!source || !sourceData || !("coordinates" in sourceData))
            return;
        if (sourceData.coordinates != null) {
            source.setCoordinates(
            //@ts-ignore
            sourceData.coordinates);
        }
    };
    const updateCoordinates = (_sourceData) => {
        var _a;
        if (!source)
            return;
        if (_sourceData.type === "canvas") {
            sourceData.coordinates = _sourceData.coordinates;
        }
        if (_sourceData.type === "video") {
            // (sourceData as VideoSource).setCoordinates(_sourceData.coordinates ?? []);
            sourceData.setCoordinates(((_a = _sourceData === null || _sourceData === void 0 ? void 0 : _sourceData.coordinates) !== null && _a !== void 0 ? _a : []));
        }
    };
    const updateVector = (_sourceData) => {
        if ("setUrl" in sourceData && "setTiles" in sourceData) {
            console.warn("Vector sources not functional yet, please contact Catchup Application if this is a must for you!");
        }
        else {
            console.warn(`Unable to update <Source> id: ${id} prop: ${_sourceData.url}, ${_sourceData.tiles}`);
        }
    };
    const mount = () => {
        if (!map) {
            console.error(`While mounting source "${id}", no map instance was found`);
            return undefined;
        }
        const _currentSource = map.getSource(id);
        if (!_currentSource) {
            map.addSource(id, sourceData);
            setSource(map.getSource(id));
        }
        return unmount;
    };
    const unmount = () => {
        removeSource();
    };
    useEffect(updateSource, [props.sourceData.type, source]);
    useEffect(updateImageURL, [
        props.sourceData.url,
        source,
    ]);
    useEffect(updateImageCoordinates, [
        imageCoordinates[0],
        imageCoordinates[1],
        source,
    ]);
    useEffect(updateGeoJSONData, [
        props.sourceData.data,
    ]);
    useEffect(mount, []);
    // The Layers
    if (map.getSource(id)) {
        // @ts-ignore because of dumbass jsx lintings
        return props.layerRender(map, id);
    }
    else
        return null;
};
